export default "__VITE_ASSET__DlpEVSyO__"